import {handleError} from 'redux/modules/error/actions'

export default store => next => action => {
  if ((action.status === 500 && action.type !=='APP_SETTINGS_FAILURE') || (action.type.includes('FAILURE') && !action.errorsHandled)) {
    next(handleError(action))
  }
  next(action)
}



// WEBPACK FOOTER //
// ./client/redux/middleware/error.js